import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./layouts/login/login";
import SingupMainCat from "./layouts/login/signup_main_cat";
import Signup from "./layouts/login/signup";
import Home from "./layouts/home";
import EventDetails from "./layouts/event_details";
import UpdateProfilePic from "./layouts/user/update_profile_pic";
import Profile from "./layouts/user/profile";
import EditProfile from "./layouts/user/edit_profile";
import CreateArtistProfile from "./layouts/user/create_artist_profile";
import SubPayment from "./layouts/user/sub_payment";
import AddArtistPhotos from "./layouts/user/add_artist_photos";
import ArtistProfile from "./layouts/user/artist_profile";
import PostHome from "./layouts/posthome";
import CreatePost from "./layouts/posts/create_post";
import CreateEvent from "./layouts/events/create_event";
import ApproachDetails from "./layouts/user/approach_details";
import MessageUsers from "./layouts/message/message_users";
import BoostProfile from "./layouts/user/boost_profile";
import SocialLinks from "./layouts/user/social_links";
import PasswordReset from "./layouts/user/password_reset";
import BlockedUsers from "./layouts/user/blocked_users";
import EditEvent from "./layouts/events/edit_event";
import AccountStatus from "./layouts/user/account_status";
import RetUsername from "./layouts/login/ret_username";
import RetPassword from "./layouts/login/ret_password";
import SavedEvents from "./layouts/saved_events";
import SavedPosts from "./layouts/saved_posts";
import ArchPostWrap from "./layouts/posts/arc_post_wrap";
import ArchivedPosts from "./layouts/archived_posts";
import SinglePost from "./layouts/single_post";
import ManageStorage from "./layouts/manage_storage";
import PurchaseStorage from "./layouts/user/purchase_storage";
import PreSignup from "./layouts/login/pre_signup";
import Declaration from "./layouts/declaration";
import KycPending from "./layouts/kyc_pending";
import VideoKycPending from "./layouts/video_kyc_pending";
import SelectPlatform from "./layouts/posts/select_platform";
import ContactRequests from "./layouts/user/contact_requests";
import { useEffect } from "react";
import { UploadProvider } from "./layouts/events/upload_context";
const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/posts',
    element: <PostHome />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/ret_username',
    element: <RetUsername />
  },
  {
    path: '/post_id/:postId',
    element: <SinglePost />
  },
  {
    path: '/ret_password',
    element: <RetPassword />
  },
  {
    path: '/account_status',
    element: <AccountStatus />
  },
  {
    path: '/pre_signup',
    element: <PreSignup />
  },
  {
    path: '/select_cat/:userType',
    element: <SingupMainCat />
  },
  {
    path: '/signup/:mainCat/:subCat',
    element: <Signup />
  },
  {
    path: '/declaration/:kyc/:declaration',
    element: <Declaration />
  },
  {
    path: '/kyc_pending',
    element: <KycPending />
  },
  {
    path: '/video_kyc_pending',
    element: <VideoKycPending />
  },
  {
    path: '/update_profile_pic',
    element: <UpdateProfilePic />
  },
  {
    path: '/profile/:userId',
    element: <Profile />
  },
  {
    path: '/edit_profile',
    element: <EditProfile />
  },
  {
    path: '/sub_payment/:subId',
    element: <SubPayment />
  },
  {
    path: '/create_artist_profile',
    element: <CreateArtistProfile />
  },
  {
    path: '/artist_profile/:userId/:status?',
    element: <ArtistProfile />
  },
  {
    path: '/event_details/:eventId',
    element: <EventDetails />
  },
  {
    path: '/create_post',
    element: <CreatePost />
  },
  {
    path: '/create_post/:insta_auth_success',
    element: <CreatePost />
  },
  {
    path: '/select_platform',
    element: <SelectPlatform />
  }
  ,
  {
    path: '/create_event',
    element: <CreateEvent />
  },
  {
    path: '/edit_event',
    element: <EditEvent />
  },
  {
    path: '/approach_details/:aid/:msg?',
    element: <ApproachDetails />
  },
  {
    path: '/message_users',
    element: <MessageUsers />
  },
  {
    path: '/storage',
    element: <ManageStorage />
  },
  {
    path: '/purchase_space',
    element: <PurchaseStorage />
  },
  {
    path: '/boost_profile',
    element: <BoostProfile />
  },
  {
    path: '/social_links',
    element: <SocialLinks />
  },
  {
    path: '/password_reset',
    element: <PasswordReset />
  },
  {
    path: '/blocked_users',
    element: <BlockedUsers />
  },
  {
    path: '/contact_request',
    element: <ContactRequests />
  },
  {
    path: '/saved_events',
    element: <SavedEvents />
  },
  {
    path: '/saved_posts',
    element: <SavedPosts />
  },
  {
    path: '/archived_posts',
    element: <ArchivedPosts />
  },
]);



function App() {

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault(); // Prevents the default right-click context menu
    };

    // Attach listener globally to document
    document.addEventListener("contextmenu", handleContextMenu);

    // Clean up listener on component unmount
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return (
    <UploadProvider>
      <RouterProvider router={router} />
    </UploadProvider>
  );
}

export default App;
